module.exports = __webpack_public_path__ + "3ccfb8225d28c7f6cc8da18ab6d9e285.mp3";